import React, { useState, useEffect } from "react";
import {
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Stepper,
  Step,
  StepLabel,
  Grid,
} from "@mui/material";
import api from "../../api";
import StepCircle from "../StepCircle";

const steps = ["Detalles del Viaje", "Asignar Vehículo y Conductor"];

const AgregarViaje = ({ vehiculo, handleClose, onUpdate }) => {
  const [step, setStep] = useState(0);
  const [vehiculos, setVehiculos] = useState([]);
  const [conductores, setConductores] = useState([]);
  const [isStep1Valid, setIsStep1Valid] = useState(false);

  const [viaje, setViaje] = useState({
    origen: "",
    destino: "",
    hora_salida: "",
    hora_llegada: "",
    distancia_recorrida: "",
    vehiculo_id: "",
    conductor_id: "",
  });

  useEffect(() => {
    api.get("vehiculos/")
      .then((response) => setVehiculos(response.data))
      .catch(() => alert("Error al cargar vehículos."));

    api.get("conductores/")
      .then((response) => setConductores(response.data))
      .catch(() => alert("Error al cargar conductores."));
  }, []);

  // Prefill vehiculo_id if provided
  useEffect(() => {
    if (vehiculo) {
      setViaje((prev) => ({
        ...prev,
        vehiculo_id: vehiculo.id,
      }));
    }
  }, [vehiculo]);

  useEffect(() => {
    const { origen, destino, hora_salida, hora_llegada, distancia_recorrida } = viaje;
    setIsStep1Valid(origen && destino && hora_salida && hora_llegada && distancia_recorrida);
  }, [viaje]);

  const handleChange = (e) => {
    setViaje({ ...viaje, [e.target.name]: e.target.value });
  };

  const handleNext = () => {
    if (vehiculo) {
      handleSubmit(new Event("submit"));
    } else {
      setStep((prev) => prev + 1);
    }
  };

  const handleBack = () => setStep((prev) => prev - 1);

  const handleSubmit = (e) => {
    e.preventDefault();
    const viajeData = {
      origen: viaje.origen,
      destino: viaje.destino,
      hora_salida: viaje.hora_salida,
      hora_llegada: viaje.hora_llegada,
      distancia_recorrida: viaje.distancia_recorrida,
      vehiculo: viaje.vehiculo_id,
      conductor: viaje.conductor_id,
    };

    console.log("Sending viaje data:", viajeData);

    api.post("viajes/", viajeData)
      .then((res) => {
        alert("Viaje agregado correctamente");
        if (onUpdate) {
          onUpdate(res.data); // send the new data to parent
        }
        handleClose();
      })
      .catch(() => alert("Hubo un error al agregar el viaje."));
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}>
      <Typography variant="h6" style={{ color: "#152d51", fontWeight: "bold" }}>
        Agregar Viaje
      </Typography>
      <Stepper activeStep={step} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={StepCircle}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {step === 0 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            <TextField
              label="Origen"
              name="origen"
              value={viaje.origen}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Destino"
              name="destino"
              value={viaje.destino}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Hora de Salida"
              name="hora_salida"
              type="datetime-local"
              value={viaje.hora_salida}
              onChange={handleChange}
              fullWidth
              required
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Hora de Llegada"
              name="hora_llegada"
              type="datetime-local"
              value={viaje.hora_llegada}
              onChange={handleChange}
              fullWidth
              required
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Distancia Recorrida (km)"
              name="distancia_recorrida"
              type="number"
              value={viaje.distancia_recorrida}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleNext}
              sx={{ background: "#152d51" }}
              disabled={!isStep1Valid}
            >
              {vehiculo ? "Agregar Viaje" : "Siguiente"}
            </Button>
          </Grid>
        </Grid>
      )}

      {!vehiculo && step === 1 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel style={{ background: "white" }}>Vehículo</InputLabel>
              <Select name="vehiculo_id" value={viaje.vehiculo_id} onChange={handleChange}>
                <MenuItem value="">Sin vehículo</MenuItem>
                {vehiculos.map((vehiculo) => (
                  <MenuItem key={vehiculo.id} value={vehiculo.id}>
                    {vehiculo.patente} - {vehiculo.marca} {vehiculo.modelo}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel style={{ background: "white" }}>Conductor</InputLabel>
              <Select name="conductor_id" value={viaje.conductor_id} onChange={handleChange}>
                <MenuItem value="">Sin conductor</MenuItem>
                {conductores.map((conductor) => (
                  <MenuItem key={conductor.id} value={conductor.id}>
                    {conductor.nombre} {conductor.apellido}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" fullWidth onClick={handleBack}>
              Atrás
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ background: "#152d51" }}>
              Agregar Viaje
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

export default AgregarViaje;
